export default "__VITE_ASSET__C5l8ZotT__"